export function isIOS() {
  if (typeof window === 'undefined') return false;
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

export function isMobileFirefox() {
  if (typeof window === 'undefined') return false;
  return /Firefox/.test(navigator.userAgent) && /Mobile/.test(navigator.userAgent);
}
